import { isEmbedded, useParentPostMessage } from '@yes.technology/react-toolkit'
import { useEffect } from 'react'
import useRecoverPasswordPath from './useRecoverPasswordPath'

const RecoverPassword = () => {
  const { postMessage } = useParentPostMessage()

  const path = useRecoverPasswordPath()

  useEffect(() => {
    if (isEmbedded()) {
      postMessage({ type: 'redirect', url: `/${path}` })
    } else {
      window.location.href = `${window.fallbackSiteRenderer}${path}`
    }
  }, [postMessage, path])

  return null
}

export default RecoverPassword
